import { fireHeapEvent } from '../helpers'
import eventNames from '../constants/postDownload'

const {
  userClickedEditAndManageCodeButton,
  userClickedEmailCodeButton,
  Flowcode_PostDownloadPage_Clicked_Analytics,
  Flowcode_PostDownloadPage_Clicked_Analytics_Card
} = eventNames

const e = {
  userClickedEditAndManageCodeButton(): void {
    fireHeapEvent(userClickedEditAndManageCodeButton)
  },
  userClickedEmailCodeButton(): void {
    fireHeapEvent(userClickedEmailCodeButton)
  },
  Flowcode_PostDownloadPage_Clicked_Analytics(): void {
    fireHeapEvent(Flowcode_PostDownloadPage_Clicked_Analytics)
  },
  Flowcode_PostDownloadPage_Clicked_Analytics_Card(): void {
    fireHeapEvent(Flowcode_PostDownloadPage_Clicked_Analytics_Card)
  }
}

export default e
